import React, { useEffect } from "react";
import { IonIcon, IonSegment, IonSegmentButton, isPlatform } from "@ionic/react";
import { gridOutline, listOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";

import { setViewMode } from "../../../store/documentsSignerList";
import { selectViewMode } from "../../../store/documentsSignerList/selectors/selectViewMode";

export const ViewModeSelector: React.FC = () => {
  const viewMode = useSelector(selectViewMode);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isPlatform("desktop")) {
      dispatch(setViewMode("list"));
    }
    dispatch(setViewMode("list"));
  }, [dispatch]);

  return (
    <>
      {isPlatform("desktop") && (
        <IonSegment
          style={{ height: 35 }}
          onIonChange={(e) => {
            dispatch(setViewMode(e.detail.value || ""));
          }}
          value={viewMode}
          color="medium"
          mode="ios"
        >
          <IonSegmentButton value="list">
            <IonIcon icon={listOutline}></IonIcon>
          </IonSegmentButton>
          <IonSegmentButton value="grid">
            <IonIcon icon={gridOutline}></IonIcon>
          </IonSegmentButton>
        </IonSegment>
      )}
    </>
  );
};
